import { render, staticRenderFns } from "./ThisFeatureIsUnavailable.vue?vue&type=template&id=24bb5225&scoped=true&"
import script from "./ThisFeatureIsUnavailable.vue?vue&type=script&lang=ts&"
export * from "./ThisFeatureIsUnavailable.vue?vue&type=script&lang=ts&"
import style0 from "./ThisFeatureIsUnavailable.vue?vue&type=style&index=0&id=24bb5225&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bb5225",
  null
  
)

export default component.exports